import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID_FRONTEND,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      // loggerCallback: (level, message, containsPii) => {
      //   if (level === LogLevel.Verbose) {
      //     console.info(message);
      //   }
      // },
      // piiLoggingEnabled: false,
      // logLevel: LogLevel.Verbose,
    }
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance };